var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:[
    'scrolling-top-button',
    { 'scrolling-top-button--light': _vm.isFestivalYear } ],style:(("bottom:" + (this.bottom) + "px;right:" + (this.right) + "px;")),attrs:{"title":"回到頂端"},on:{"click":_vm.scrollToTop,"keypress":_vm.scrollToTop}},[_vm._v("頂端")])}
var staticRenderFns = []

export { render, staticRenderFns }